import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export const Contact = () => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');

  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero */}
      <section className="px-4 py-16 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-4">Get in Touch</h1>
          <p className="text-xl text-gray-600">
            Talk to us about Voice AI, integrations, or partnerships.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="px-4 py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* CONTACT FORM (Netlify) */}
          <Card className="border-2">
            <CardContent className="p-8">
              <h2 className="text-3xl font-bold mb-6">Send us a message</h2>

              <form
  name="contact"
  method="POST"
  action="/thank-you"
  data-netlify="true"
  netlify-honeypot="bot-field"
  className="space-y-6"
>
  {/* Required hidden fields */}
  <input type="hidden" name="form-name" value="contact" />
  <input type="hidden" name="bot-field" />

  <div>
    <Label>Name *</Label>
    <Input name="name" required placeholder="Your name" />
  </div>

  <div>
    <Label>Email *</Label>
    <Input
      name="email"
      type="email"
      required
      placeholder="you@email.com"
    />
  </div>

  <div>
    <Label>Company</Label>
    <Input name="company" placeholder="Company name" />
  </div>

  <div>
    <Label>Message *</Label>
    <Textarea
      name="message"
      required
      rows={5}
      placeholder="How can we help?"
    />
  </div>

  <Button
    type="submit"
    className="w-full py-6 text-lg bg-gradient-to-r from-purple-600 to-pink-600"
  >
    Send Message
  </Button>
</form>


            </CardContent>
          </Card>

          {/* CONTACT INFO */}
          <div className="space-y-6">
            <InfoCard icon={<Mail />} title="Email" value="Allwin1691@gmail.com" />
            <InfoCard icon={<Phone />} title="Phone" value="9599082433" />
            <InfoCard icon={<MapPin />} title="Office" value="Bangalore, India" />
          </div>
        </div>
      </section>

      {/* NEWSLETTER */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Stay Updated</h2>

          <form
  name="newsletter"
  method="POST"
  action="/thank-you"
  data-netlify="true"
  netlify-honeypot="bot-field"
  className="flex gap-4"
>
  <input type="hidden" name="form-name" value="newsletter" />
  <input type="hidden" name="bot-field" />

  <Input
    type="email"
    name="email"
    required
    placeholder="Your email"
  />
  <Button type="submit">Subscribe</Button>
</form>
        </div>
      </section>
    </div>
  );
};

const InfoCard = ({ icon, title, value }) => (
  <Card className="border-2">
    <CardContent className="p-6 flex items-start gap-4">
      <div className="w-12 h-12 bg-purple-100 flex items-center justify-center rounded-lg">
        {icon}
      </div>
      <div>
        <h3 className="font-semibold">{title}</h3>
        <p className="text-gray-600">{value}</p>
      </div>
    </CardContent>
  </Card>
);
